import gql from 'graphql-tag';
import createQuery from './createQuery';

export default createQuery(gql`
  mutation setBasicAuthKey($token: String!, $key: String!, $data: JSON!) {
    setBasicAuthKey(token: $token, key: $key, data: $data)
  }
`);
